import React from "react";
import { createPortal } from "react-dom";
import Button from "../form/Button";
import { useSelector } from "react-redux";

const headingLang = {
  en: "Are you sure you want to logout?",
  es: "¿Estás seguro de que quieres cerrar sesión?",
  it: "Sei sicuro di voler uscire?",
};
const cancelLang = {
  en: "Cancel",
  es: "Cancelar",
  it: "Cancellare",
};
const logoutLang = {
  en: "Logout",
  es: "Cerrar sesión",
  it: "Esci",
};

const LogoutModal = ({ show, onClose, onConfirm, loaded = true }) => {
  const lang = useSelector((state) => state?.languageSlice?.data);
  const language = localStorage.getItem("language") || lang;
  if (!show) return null;

  const node = (
    <div className="fixed inset-0 flex items-center justify-center z-[200] bg-gray-800/50">
      <div className="bg-white rounded-lg shadow-lg md:w-96 w-72 p-5">
        <div className="text-center">
          <span className="md:text-6xl text-5xl text-yellow-500 mb-2">
            <i className="fa-solid fa-triangle-exclamation"></i>
          </span>
          <p className="mb-4">{headingLang?.[language]}</p>
        </div>
        <div className="flex justify-center gap-3">
          <Button
            buttonHasLink={false}
            buttonFunction={onClose}
            buttonLabel={`${cancelLang?.[language]}`}
            buttonIcon={"fa-light fa-xmark"}
            buttonIconPosition={"left"}
            buttonClasses={"uppercase text-sm hover:!bg-prontopsy-blue"}
          />

          <Button
            buttonHasLink={true}
            buttonLink={"/"}
            buttonLabel={`${logoutLang?.[language]}`}
            buttonIcon={"fa-regular fa-right-from-bracket"}
            buttonIconPosition={"left"}
            buttonClasses={"uppercase text-sm hover:!bg-prontopsy-blue"}
            buttonFunction={onConfirm}
            isDisable={!loaded}
          />
        </div>
      </div>
    </div>
  );

  if (typeof document === "undefined" || !document.body) return node;
  return createPortal(node, document.body);
};

export default LogoutModal;
